import * as React from 'react';
import { Button } from 'primereact/button';
import { Alert } from 'reactstrap';
import { ProgressBar } from 'primereact/progressbar';
import { useAuth0 } from '../../../auth/react-auth0-wrapper'
import Can from "../../../auth/Can";
import roles from "../../../auth/roles";
import moment from 'moment';

export default function CanTestAnswer({
    trigger,
    verify,
    triggerNextStep,
    deviceId,
    step
}) {
    const { gisApi } = useAuth0();
    const [loading, setLoading] = React.useState(false);
    const completed = step.value && step.value.completed;
    const error = step.value && step.value.error;
    const [canCode, setCanCode] = React.useState();

    const [position, setPositionResult] = React.useState();

    const checkValidState = position => {
        const on = position.attributes.coolantTemp > 0 ? true : false;
        return verify === 'on' ? on : !on;
    };

    async function executeTestCan() {
        setLoading(true);
        const commandResult = await gisApi.getLastCommandResult(deviceId);
        setLoading(false);
        if (!commandResult) {
            return {
                ok: false,
                error: `Impossibile rilevare la posizione e/o i dati dal dispositivo. Controllare il corretto funzionamento del dispositivo e riprovare.`
            };
        }
        const canData = commandResult.attributes.result.split(" ");
        const canCodeResult = parseInt(canData[0].slice(5));
        if (canCodeResult==0) {
            console.log("CANCODE", canCodeResult);
            return {
                ok: false,
                error: `Linea CAN rilevata con codice 0. Controllare la corretta installazione della linea CAN.`
            };
        }
        getRecordDevice();
        setCanCode(canCodeResult);
        return { ok: true, canCode };
    }

    async function getRecordDevice() {
        setLoading(true);
        const command = "getrecord";
        await gisApi.sendComand(
            deviceId,
            command,
            command,
            false
        );                
        const posRes = await gisApi.getLastPosition(deviceId);
        setPositionResult(posRes);
        setLoading(false);
    }

    return (
        <div>
            <Alert
                color={error ? 'danger' : completed ? 'success' : 'info'}
                title={"Test corretta installazione della linea CAN"}
            >
                <div>

                    {loading && (
                        <div>
                            <div>{'Rilevamento installazione della linea CAN in corso...'}</div>
                            <ProgressBar className="mb-2" mode="indeterminate" style={{ height: '8px' }} />
                        </div>
                    )}
                    
                    {error && <div className="text-red mb-4">{error}</div>}
                    
                    {canCode && !completed && (
                        <div>
                            {`Linea CAN rilevata con codice: ${canCode}`}
                        </div>
                    )}

                    {canCode && position && !completed && !loading && (
                        <div>
                            {`Rilevati valori di: Carburante: ${position.attributes.fuel || `n.d.`} (${position.attributes.FuelPercentage || `n.d.`} %) - Refrigerante: ${position.attributes.coolantTemp || `n.d.`} - Giri motore: ${position.attributes.rpm || `n.d.`}`}
                        </div>
                    )}

                    {canCode==0 && !completed && (
                        <div>
                            {`Linea CAN non rilevata, codice di ritorno: ${canCode}`}
                        </div>
                    )}

                    {completed && (
                        <div className="text-green mb-4">
                            {
                                `Linea CAN correttamente installata e verificata`
                            }
                        </div>
                    )}

                    {!error && !completed && !canCode && (
                        <div>
                            <div>
                                {`Effettuare il test della linea CAN per il corretto rilevamento dei dati del veicolo`}
                            </div>
                            <Button
                                disabled={loading}
                                label={`Test linea CAN`}
                                icon="pi pi-check"
                                onClick={async () => {
                                    const testResult = await executeTestCan();
                                    if (!testResult.ok) {
                                        triggerNextStep({
                                            trigger: step.id,
                                            value: { error: testResult.error, timestamp: moment().toJSON() }
                                        });
                                    }
                                }}
                                className="p-button-info p-button-rounded"
                            />
                            <Button
                                className="p-button-danger p-button-rounded ml-2"
                                label={'Annulla test linea CAN'}
                                icon="fas fa-fast-forward"
                                onClick={async () => {
                                    if (confirm('Confermi di annullare il test della linea CAN?')) {
                                        triggerNextStep({
                                            trigger: 'test-can-end',
                                            value: { error: `Test linea CAN annullata dall'operatore`, timestamp: moment().toJSON() }
                                        });
                                    }
                                }}
                            />

                            <Can
                                roles={[roles.ADMIN]}
                                yes={() =>
                                    <Button
                                        className="p-button-danger p-button-rounded ml-2"
                                        label={'FORZA TEST'}
                                        icon="fas fa-fast-forward"
                                        onClick={async () => {
                                            if (confirm('Confermi di voler forzare il test della linea CAN?')) {
                                                triggerNextStep({
                                                    trigger: 'test-can-end',
                                                    value: { skipped: true, completed: true, timestamp: moment().toJSON() }
                                                });
                                            }
                                        }}
                                    />
                                }
                                no={() => null}
                            />
                        </div>
                    )}

                    {!error && !completed && canCode && (
                        <div>
                            <div className="mb-2">{`Confermi i dati? (alcuni dati potrebbero non essere disponibili - n.d.)`}</div>
                            <Button
                                label={`SI`}
                                icon="pi pi-check"
                                style={{ marginRight: "5px" }}
                                onClick={() => {
                                    triggerNextStep({
                                        trigger: trigger,
                                        value: { completed: true, timestamp: moment().toJSON() }
                                    });
                                }}
                                className="p-button-success p-button-rounded"
                            />

                            <Button
                                disabled={loading}
                                label={`NO`}
                                icon="pi pi-times"
                                style={{ marginRight: "5px" }}
                                onClick={async () => {
                                    const testResult = await executeTestCan();
                                    triggerNextStep({
                                        trigger: step.id,
                                        value: {
                                            error: `Nessun dato rilevato dalla Linea CAN. Ripetizione rilevamento dati dalla linea CAN...`, timestamp: moment().toJSON()
                                        }
                                    });
                                }}
                                className="p-button-danger p-button-rounded"
                            />

                            <Button
                                label={`ANNULLA E RIPETI TEST`}
                                icon="pi pi-times"
                                style={{ marginRight: "5px" }}
                                onClick={async () => {
                                    triggerNextStep({
                                        trigger: 'test-can-start',
                                        value: {
                                            error: `Annullato dall'operatore per mancanza di dati. Ripetizione del test della linea CAN`, timestamp: moment().toJSON()
                                        }
                                    });
                                }}
                                className="p-button-danger p-button-rounded"
                            />

                            <Can
                                roles={[roles.ADMIN]}
                                yes={() =>
                                    <Button
                                        className="p-button-danger p-button-rounded ml-2"
                                        label={'FORZA TEST'}
                                        icon="fas fa-fast-forward"
                                        onClick={async () => {
                                            if (confirm('Confermi di voler forzare il test della linea CAN?')) {
                                                triggerNextStep({
                                                    trigger: 'test-can-end',
                                                    value: { skipped: true, completed: true, timestamp: moment().toJSON() }
                                                });
                                            }
                                        }}
                                    />
                                }
                                no={() => null}
                            />
                        </div>
                    )}
                </div>
            </Alert>
        </div>
    );
}
